export class SyncTimestampDto {
  timestamp: Date;
  archived: boolean;

  constructor(public _id: string, public latestTimestamp: Date, public documentCount: number = 0) {
    this.timestamp = new Date();
  }
}
